import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { handle } from "@dp/common";
import DPServices, { WineListTypes } from "@dp/services";
import { computed, reaction } from "mobx";
import Base from "./Base";
import Errors from "./Errors";
import { WineListModel } from "./models/WineListModel";
var WineList = (_class = /*#__PURE__*/function (_Base) {
  _inherits(WineList, _Base);

  var _super = _createSuper(WineList);

  function WineList(rootStore) {
    var _this;

    _classCallCheck(this, WineList);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "wineListModel", null);

    _this.rootStore = rootStore;
    _this.wineListModel = new WineListModel();
    return _this;
  }

  _createClass(WineList, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.wineListModel.reset();
                return _context3.abrupt("return", Promise.resolve());

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this;

      reaction(function () {
        return {
          activeCategory: _this2.wineListModel.activeCategory
        };
      }, function (data) {
        if (data.activeCategory) {
          _this2.wineListModel.processActiveCategoryChange();
        }
      });
    }
  }, {
    key: "_processWineListResponse",
    value: function () {
      var _processWineListResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(response) {
        var _this3 = this,
            _this$wineListModel;

        var winesObjForUI;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                winesObjForUI = {
                  varietalName: {},
                  flavorName: {},
                  regionName: {},
                  NinetyPointClub: [],
                  pairings: {},
                  halfBottles: [],
                  largeFormat: []
                };
                response.wines.forEach(function (wine) {
                  var wineSize = _this3.wineListModel.getWineSizeByBottleSize(wine.bottleSize);

                  if (wineSize === WineListTypes.WineSize.LARGE_FORMAT) {
                    winesObjForUI.largeFormat.push(wine);
                  } else if (wineSize === WineListTypes.WineSize.HALF_BOTTLE) {
                    winesObjForUI.halfBottles.push(wine);
                  }

                  if (_this3.isWinePartOfNinetyPointClub(wine)) {
                    winesObjForUI.NinetyPointClub.push(wine);
                  }

                  if (_this3.isWinePairingAvailable(wine)) {
                    var pairingCodes = wine.winePairingCodes.map(function (pairing) {
                      return pairing.winePairingCode;
                    });
                    pairingCodes.forEach(function (code) {
                      if (winesObjForUI.pairings[code]) {
                        winesObjForUI.pairings[code].push(wine);
                      } else {
                        winesObjForUI.pairings[code] = [wine];
                      }
                    });
                  }

                  for (var cat in winesObjForUI) {
                    var wineObjectCategory = winesObjForUI[cat];
                    var wineCategory = wine[cat];

                    if (wineCategory) {
                      if (wineObjectCategory[wineCategory]) {
                        wineObjectCategory[wineCategory].push(wine);
                      } else {
                        wineObjectCategory[wineCategory] = [wine];
                      }
                    }
                  }
                });
                this.wineListModel.winesObjectForUI = winesObjForUI;
                this.wineListModel.activeCategory = (_this$wineListModel = this.wineListModel) === null || _this$wineListModel === void 0 ? void 0 : _this$wineListModel.categories[0];
                this.wineListModel.processActiveCategoryChange();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _processWineListResponse(_x) {
        return _processWineListResponse2.apply(this, arguments);
      }

      return _processWineListResponse;
    }()
  }, {
    key: "isWinePartOfNinetyPointClub",
    value: function isWinePartOfNinetyPointClub(wine) {
      return wine.badges.some(function (badge) {
        return badge.name === WineListTypes.Name.The90PtClub;
      });
    }
  }, {
    key: "isWinePairingAvailable",
    value: function isWinePairingAvailable(wine) {
      if (wine.winePairingCodes && wine.winePairingCodes.length > 0) {
        var updatedWinePairingCodesAndNames = this.wineListModel.winePairingCodesAndNames;
        wine.winePairingCodes.forEach(function (pairing) {
          var pairingCode = updatedWinePairingCodesAndNames === null || updatedWinePairingCodesAndNames === void 0 ? void 0 : updatedWinePairingCodesAndNames[pairing === null || pairing === void 0 ? void 0 : pairing.winePairingCode];

          if (!pairingCode) {
            updatedWinePairingCodesAndNames[pairing.winePairingCode] = pairing.name;
          }
        });
        this.wineListModel.winePairingCodesAndNames = updatedWinePairingCodesAndNames;
        return true;
      }

      return false;
    }
  }, {
    key: "wineListSelectLocation",
    value: function () {
      var _wineListSelectLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(restaurantNumber) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.wineListModel.restaurantNumber === restaurantNumber)) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                _context5.prev = 4;
                _context5.next = 7;
                return this.getWineList(restaurantNumber);

              case 7:
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](4);
                throw _context5.t0;

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 9]]);
      }));

      function wineListSelectLocation(_x2) {
        return _wineListSelectLocation.apply(this, arguments);
      }

      return wineListSelectLocation;
    }()
  }, {
    key: "getRelatedWineCategory",
    value: function getRelatedWineCategory(wineId, varietalName, vintage, region, subRegion, bootlePrice) {
      var subRegionReplaced = subRegion;

      if (subRegionReplaced && subRegionReplaced.includes("'")) {
        subRegionReplaced = subRegionReplaced.replace(/'/g, "");
      }

      var matchingWines = [];
      var priceFactor1 = 1.3;
      var priceFactor2Min = 1.31;
      var priceFactor2Max = 1.5;
      this.wineListModel.winesList.wines.forEach(function (wine) {
        var condition1 = wine.wineID !== wineId;
        var condition2 = !varietalName || wine.varietalName === varietalName;
        var condition3 = !vintage || wine.vintage === vintage;
        var condition4 = !region || wine.regionName === region || !subRegionReplaced || wine.subregionName === subRegionReplaced;
        var condition5 = wine.bottlePrice >= bootlePrice * priceFactor1;

        if (condition1 && condition2 && condition3 && condition4 && condition5) {
          matchingWines.push(wine);
        }
      });
      var matchingWines2 = matchingWines.filter(function (wine) {
        var condition7 = wine.bottlePrice >= bootlePrice * priceFactor2Min;
        var condition8 = wine.bottlePrice <= bootlePrice * priceFactor2Max;
        return condition7 && condition8;
      });
      return matchingWines2.slice(0, 2);
    }
  }, {
    key: "getWineList",
    value: function () {
      var _getWineList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(restaurantNumber) {
        var _yield$handle, _yield$handle2, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return handle(DPServices.WineList.getWinelist(restaurantNumber));

              case 3:
                _yield$handle = _context6.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                error = _yield$handle2[0];
                response = _yield$handle2[1];

                if (!error) {
                  _context6.next = 10;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || error.message ? error : Errors.GET_WINELIST_FAILED;
                throw errorDescription;

              case 10:
                if (!response) {
                  _context6.next = 17;
                  break;
                }

                this.wineListModel.searchText = null;
                this.wineListModel.searchResults = [];
                this.wineListModel.winesList = response;
                _context6.next = 16;
                return this._processWineListResponse(response);

              case 16:
                this.wineListModel.restaurantNumber = restaurantNumber;

              case 17:
                _context6.next = 22;
                break;

              case 19:
                _context6.prev = 19;
                _context6.t0 = _context6["catch"](0);
                throw _context6.t0;

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 19]]);
      }));

      function getWineList(_x3) {
        return _getWineList.apply(this, arguments);
      }

      return getWineList;
    }()
  }, {
    key: "filterControlsHeaderList",
    get: function get() {
      var _this4 = this;

      var activeFilters = this.wineListModel.getActiveFilters();
      var filtersArray = [];

      if (activeFilters) {
        var _loop = function _loop() {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              filterName = _Object$entries$_i[0],
              appliedFilters = _Object$entries$_i[1];

          if (filterName === WineListTypes.FilterNames.PRICE) {
            var currentMinPrice = appliedFilters.min;
            var currentMaxPrice = appliedFilters.max;

            if (currentMaxPrice < _this4.wineListModel.currentFilters.PRICE.MAX_LIMIT || currentMinPrice > _this4.wineListModel.currentFilters.PRICE.MIN_LIMIT) {
              filtersArray.push({
                filterName: filterName,
                value: "$".concat(currentMinPrice, " to $").concat(currentMaxPrice)
              });
            }
          } else {
            if (appliedFilters.length > 0) {
              var updatedFiltersArray = appliedFilters.map(function (filterValue) {
                return {
                  filterName: filterName,
                  value: filterValue
                };
              });
              filtersArray.push.apply(filtersArray, _toConsumableArray(updatedFiltersArray));
            }
          }
        };

        for (var _i = 0, _Object$entries = Object.entries(activeFilters); _i < _Object$entries.length; _i++) {
          _loop();
        }
      }

      return filtersArray;
    }
  }]);

  return WineList;
}(Base), _applyDecoratedDescriptor(_class.prototype, "filterControlsHeaderList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "filterControlsHeaderList"), _class.prototype), _class);
export { WineList as default };